import * as React from "react";
import { useEffect } from "react";
import * as jQuery from "jquery";
import "jquery.qtip2";
import I18n from 'i18n';

interface ITooltipProps {
  heading?: string;
  tooltipHeadline?: string;
  tooltipBody: JSX.Element | string;
  positionMy?: string;
  positionAt?: string;
  toggle?: JSX.Element;
  badge?: boolean;
  children?: any;
}

const fadeInDelay = 250;
const fadeInDuration = 500;
const fadeOutDelay = 750;
const fadeOutDuration = 500;
const opaqueAlpha = 1;
const transparentAlpha = 0;

const Tooltip = React.forwardRef<HTMLDivElement, ITooltipProps>(({
  heading,
  tooltipHeadline,
  tooltipBody,
  positionMy,
  positionAt,
  toggle,
  badge,
  children,
}: ITooltipProps) => {
  const tooltipToggleRef = React.useRef<HTMLElement>(null);
  const tooltipContentRef = React.useRef<HTMLElement>(null);

  const toggleElement = toggle || children || <i className="icon-question-wrapped"></i>;

  useEffect(() => {
    const tooltipToggle = tooltipToggleRef.current as HTMLElement;
    if (tooltipToggle) {
      jQuery(tooltipToggle).qtip(tooltipOptions());
    }
    return () => {
      const tooltipToggle = tooltipToggleRef.current as HTMLElement;
      if (tooltipToggle) {
        jQuery(tooltipToggle).qtip("destroy");
      }
    };
  }, [tooltipBody, positionMy, positionAt]);

  const tooltipOptions = () => {
    return {
      content: jQuery(tooltipContentRef.current as HTMLElement),
      style: { classes: "bluereport-tooltip" },
      show: {
        effect: function () {
          jQuery(this).fadeTo(fadeInDuration, opaqueAlpha);
        },
        delay: fadeInDelay
      },
      hide: {
        effect: function () {
          jQuery(this).fadeTo(fadeOutDuration, transparentAlpha);
        },
        delay: fadeOutDelay
      },
      position: {
        my: positionMy || "bottom center",
        at: positionAt || "top center"
      }
    };
  };

  if (heading) {
    return (
      <h3 className="heading-medium mbs">
        {heading}&nbsp;
        <span className="tooltip">
          <span
            className="tooltip__toggle tooltip__toggle--html"
            ref={tooltipToggleRef}
          >
            {toggleElement}
          </span>
          <span
            className="tooltip__content tooltip__content--html"
            ref={tooltipContentRef}
          >
            {tooltipHeadline && <h1 className="tooltip__title">{tooltipHeadline}</h1>}
            {tooltipHeadline && <br />}
            <span className="tooltip__text">{tooltipBody}</span>
          </span>
        </span>
      </h3>
    );
  }

  return (
    <span className="tooltip">
      <span
        className="tooltip__toggle tooltip__toggle--html"
        ref={tooltipToggleRef}
      >
        {toggleElement}
        {badge && (
          <span
            className="badge"
            style={{ marginLeft: '9px', verticalAlign: 'unset' }}
          >
            {I18n.t('webapp.agents.edit.source_categories.print_badge')}
          </span>
        )}
      </span>
      <span
        className="tooltip__content tooltip__content--html"
        style={{ marginTop: '-1em' }}
        ref={tooltipContentRef}
      >
        <br />
        <span className="tooltip__text">{tooltipBody}</span>
      </span>
    </span>
  );
});

Tooltip.displayName = 'Tooltip';

export default Tooltip;
